import React from 'react';
import PropTypes from 'prop-types';
import {get} from './Storage';
import WidgetBadges from './Widget/WidgetBadge';
import Avatar from 'material-ui/Avatar';
import {Card, CardHeader, CardText, CardMedia} from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import { DateTool} from "mgToolsKit";

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'MGMissionComponent';

var styles = AppSettings.styles;

class Mission extends React.Component {
    constructor(props) {
        super(props);
        this.state = {            
            opened: false
        }
        this.loadBadges = this.loadBadges.bind(this);
        this.goToPage = this.goToPage.bind(this);
    }

    componentDidMount() {
        this.setState({ opened: false});
    }  

    goToPage(){
              
        if(this.props.mission.PageLink != "" && this.props.mission.PageLink!=null){           
            //location.href = this.props.data.PageLink;
            window.open(decodeURI(this.props.mission.PageLink),"Regolamento");
        };  
        
    }

    loadBadges() {
        if(this.state.opened){
            this.setState({                
                opened:false
            });
            return;
        }
        this.setState({            
            opened:true
        });

       
    }
    renderBadges(){
       
        return (
            <>
                {(() => {
                    var badgesNodes = "";
                    var badgesList=this.props.mission.Badges;
                    var mType=this.props.mission.Type;
                    if (badgesList.length > 0) {
                        badgesNodes = badgesList.map(function (badge, i) {
                            var key = badge.Code;                           
                            if(mType!=null){
                                badge.mType = mType;
                            }
                            return (
                                <WidgetBadges key={key} data={badge}  />
                            )
                        });
                        return (
                            <>
                                {badgesNodes}
                            </>
                        )                        
                    }
                   
                })()}
            </>
        )
    } 

    render() {
        var Type = {    
            "0": "progressiva",            
            "1": "libera",
            "2": "mista"                
        };
       
         var color = "";
         if (!this.props.mission.Old) {
             color = AppSettings.theme.primarycolor
         }
        var title = <div style={styles.pointer} > {this.props.mission.Name}</div>;
        var url = this.props.mission.PageLink;
        var description  = <div style={styles.pointer} >{this.props.mission.Description}
                           
                            </div>;
        var key = "mission_" + this.props.mission.Id;
        //var avatar = <Avatar backgroundColor={color} className="userbox-avatar" color="#fff">M</Avatar>;
        var type = Type[this.props.mission.Type];//0 progressiva semplice bsr quanto manca per badge successivo, 2 progressiva su tipologia diverse , 1 libera
        var missionAge = "active";
        var missionState="";
        if(this.props.mission.Old==1)
            missionAge = "old";  
        var missionComplete = Array.prototype.every.call(this.props.mission.Badges, (x) => x.Score >0);
        if (missionComplete)
            missionState="won";
        var classMission = "mg-mission-item " + type+" "+missionAge+" "+missionState;   

        //var classMission = "mg-mission-item "+type;
        var _dateDa =  new DateTool(parseInt(this.props.mission.StartScheduledDate.replace(/(^.*\()|([+-].*$)/g, '')));
        var dateDa = _dateDa.convertDate().StringDate;
        var _dateA =  new DateTool(parseInt(this.props.mission.EndScheduledDate.replace(/(^.*\()|([+-].*$)/g, '')));
        var dateA = _dateA.convertDate().StringDate;
        var latestUpdate = this.props.mission.Upd;
        var image=<i className="fa-mg fa-mg-award mg-user-icon"></i>;
        return (            
            <Card key={key}  
            expanded = {this.state.opened} 
            onExpandChange = {this.loadBadges} 
            className = {classMission} 
            containerStyle={styles.mgCardStyle} 
            >
            {/* <CardMedia
            component="img"
            //height="194"
            image="https://marketing.microgame.it/l.ashx?u=img/banner/mission-ub.png"
            alt="Visualizza missione"
            /> */}
            
                <CardHeader 
                    titleStyle={styles.mgCardTitle}
                    subtitleStyle={styles.mgCardSubTitle}
                    title={title}
                    subtitle={description}
                    
                    avatar={image}
                    //component={image}
                    actAsExpander={true}
                    showExpandableButton={true}
                    style={styles.primaryBorderColor}/>            
                     <div className="mg-mission-date">
                        <p>Valida dal {dateDa} al {dateA}</p>
                        <p>Ultimo aggiornamento: {latestUpdate}</p>
                    </div>  
                <CardText expandable={true} style={styles.cardText}>
                    {this.renderBadges()}
                                     
                    {url!="" && url!=null?
                    <RaisedButton label={"Scopri di più"}
                                className="mg-mission-button"
                                onClick={this.goToPage}
                                primary={true}
                                style={styles.fullWidth}
                                labelStyle={styles.labelWhite} />
                    :
                    ""
                    }
                </CardText>
            </Card>        

        );

    }
}

Mission.displayName = componentName;

// PropTypes validation
Mission.propTypes = {
    mission:PropTypes.object.isRequired

};

// default props
Mission.defaultProps = {
    mission:{}

};
// contextTypes validation
Mission.contextTypes = {
   
}
export default Mission;